import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { TelaCarregando } from '../componentes/TelaCarregando.js';
import { useSessao } from './SessaoContexto.js';

/**
 * Portão de todas as rotas do painel.
 *
 * Enquanto a sessão não foi verificada, mostra espera — nunca conteúdo. Sem
 * sessão, manda ao login guardando de onde a pessoa veio, para voltar ao
 * mesmo lugar depois de entrar.
 */
export function RotaProtegida() {
  const { estado } = useSessao();
  const localizacao = useLocation();

  if (estado.situacao === 'carregando') {
    return <TelaCarregando mensagem="Verificando a sessão…" />;
  }

  if (estado.situacao === 'anonimo') {
    return <Navigate to="/entrar" replace state={{ de: localizacao.pathname }} />;
  }

  return <Outlet />;
}
